import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import DropdownActionsWrapper from '@/components/probaworkflows_base_components/DropdownActionsWrapper/DropdownActionsWrapper.vue'
import global_table_methods from './global_table_methods';

export default {
  name: 'GlobalTable',
  components: {
    DropdownActionsWrapper
  },
  data: () => ({
    is_initializing: false,
    hidden_column_ids: [],
    table_fits_container: false,
  }),
  props: {
    headers: Array,
    data: Array,
    fields: Array,
    table_id: {
      type: String,
      default: 'global_table'
    },
    use_action_dropdown: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: Boolean,
      default: true
    },
    enable_column_toggle: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.initialize_data_table();
  },
  methods: global_table_methods,
  watch: {
    data() {
      this.initialize_data_table();
    },
    headers() {
      this.hidden_column_ids = this.hidden_column_ids.filter((column_id) =>
        (this.headers || []).some((header) => this.get_column_id(header) === column_id)
      );
      this.initialize_data_table();
    }
  },
  beforeUnmount() {
    this.unbind_header_toggle_events();
    this.destroy_data_table();
  }
};
